'use client'
import Xpayz from '@svg/xpayz.svg'

import Divider from './common/Divider'
import Typography from './common/Typography'
import Link from 'next/link'
import {useState} from 'react'
import DocsDialog from './common/DocsDialog'

export default function Footer() {
  const links = {
    Products: [
      {text: 'Payment Gateway', url: '/products#payment-gateway'},
      {text: 'Payment Links', url: '/products#payment-links'},
      {text: 'Invoices', url: '/products#invoices'},
      {text: 'Merchant Accounts', url: '/products#merchant-accounts'},
    ],
    Tokens: [
      {text: 'USXP', url: '/tokens#usxp'},
      {text: 'BRXP', url: '/tokens#brxp'},
      {text: 'Token Framework', url: '/tokens#token-framework'},
    ],
    'Compliance & Legal': [
      {text: 'Compliance Framework', url: '/compliance#compliance-framework'},
      {text: 'Security', url: '/security'},
      {text: 'Restricted Use', url: '/compliance#restricted-use'},
    ],
    Company: [
      {text: 'How it Works', url: '/how-it-works'},
      {text: 'FAQ', url: '/faq'},
      {text: 'Contact', url: '/contact'},
    ],
  }

  const [showDocDialog, setShowDocDialog] = useState(false)
  const docs = [
    {
      title: 'ThePayHub - Legal Opinion USXP and BRXP',
      url: '/docs/Legal_Opinion_USXP_BRXP_ThePayHub.pdf',
    },
  ]

  return (
    <footer className="h-auto max-w-full flex flex-col items-center justify-between gap-5 py-16 px-4 md:px-10 bg-gray-900">
      <div className="flex flex-col gap-10 items-center justify-center w-full max-w-7xl">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 justify-between w-full max-w-7xl">
          {Object.entries(links).map(([section, items], index) => (
            <div key={index} className="flex flex-col gap-4 m-4">
              <Typography size="sm" className="text-white! ">
                {section}
              </Typography>
              {items.map((item, index) => (
                <Link key={index} href={item.url}>
                  <Typography size="sm" className="text-sub-200! hover:text-white! transition-colors duration-200">
                    {item.text}
                  </Typography>
                </Link>
              ))}
            </div>
          ))}
        </div>
        <Divider className="bg-gray-800!" />
        <div className="w-full flex flex-col gap-10">
          <div className="flex justify-between flex-wrap gap-4">
            <Xpayz className="w-18.5 text-white" />
            <ul className="flex gap-3 text-sm text-sub-200">
              <li>
                <Link href="/terms">Terms</Link>
              </li>
              <li>
                <Link href="/privacy">Privacy</Link>
              </li>
              <li>
                <div className="cursor-pointer" onClick={() => setShowDocDialog(true)}>
                  Licensing
                </div>
              </li>
            </ul>
          </div>
          <div className="flex flex-col gap-6">
            <Typography size="sm" className="text-sub-300! w-full">
              xPayz operates a tokenized payment gateway using internal ledger-based tokens. USXP and BRXP are ledger
              entries within the xPayz platform and are not publicly traded securities, cryptocurrencies, .
              Theyrepresent balances in USD and BRL respectively for payment processing and settlement purposes within
              the xPayz ecosystem.
            </Typography>
            <Typography size="sm" className="text-sub-300! w-full">
              Access to xPayz products and services is subject to jurisdiction-specific requirements, identity
              verification, and approval. Availability varies by location and is determined based on regulatory
              assessment and compliance framework. Not all features are available in all jurisdictions.
            </Typography>
            <Typography size="sm" className="text-sub-300! w-full">
              &copy; {new Date().getFullYear()} xPayz. All rights reserved.
            </Typography>
          </div>
        </div>
      </div>
      {/* Docs Dialog */}
      <DocsDialog open={showDocDialog} onClose={() => setShowDocDialog(false)} docs={docs} />
    </footer>
  )
}
